import { TablePlaceholder, TablePlaceholderProps } from "./TablePlaceholder"
import { LoadingSpinner } from "../../../../components/base/feedback/LoadingSpinner"

export type TableLoadingPlaceholderProps = Omit<
  TablePlaceholderProps,
  "children"
>

export function TableLoadingPlaceholder({
  ...otherProps
}: TableLoadingPlaceholderProps) {
  return (
    <TablePlaceholder {...otherProps}>
      <LoadingSpinner size="large" className="color-subtle" />
    </TablePlaceholder>
  )
}
